import React, { useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import API from "../../api/api";

export default function CreateEvent() {
  const [form, setForm] = useState({
    name: "",
    date: "",
    location: "",
    ruleSet: "K-1",
    status: "draft",
    description: "",
  });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
  e.preventDefault();

  try {
    const res = await API.post("/events", {
      name: form.name,
      date: form.date,
      location: form.location,
      ruleSet: form.ruleSet,
      status: form.status,
      description: form.description,
    });

    alert("✅ Event created successfully");
    console.log("Created event:", res.data);

    // optional: redirect later
    // navigate(`/admin/events/${res.data.id}`);
  } catch (err) {
    console.error("Create event failed:", err);
    alert("❌ Failed to create event");
  }
}

  return (
    <AdminLayout>
      <div className="p-6 text-white max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">Create Event</h1>
        <p className="text-gray-400 mb-6">
          Create a fight night or gala (no brackets)
        </p>

        <form
          onSubmit={handleSubmit}
          className="bg-gray-900 p-6 rounded-xl border border-gray-700 space-y-5"
        >
          {/* EVENT NAME */}
          <div>
            <label className="block mb-1 text-sm text-gray-300">
              Event Name
            </label>
            <input
              type="text"
              name="name"
              required
              value={form.name}
              onChange={handleChange}
              placeholder="WAR FC 23: Night of Champions"
              className="w-full p-3 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:border-yellow-500"
            />
          </div>

          {/* DATE */}
          <div>
            <label className="block mb-1 text-sm text-gray-300">
              Event Date
            </label>
            <input
              type="date"
              name="date"
              required
              value={form.date}
              onChange={handleChange}
              className="w-full p-3 rounded bg-gray-800 border border-gray-700"
            />
          </div>

          {/* LOCATION */}
          <div>
            <label className="block mb-1 text-sm text-gray-300">
              Location
            </label>
            <input
              type="text"
              name="location"
              value={form.location}
              onChange={handleChange}
              placeholder="Ulaanbaatar, UG Arena"
              className="w-full p-3 rounded bg-gray-800 border border-gray-700"
            />
          </div>

          {/* RULESET */}
          <div>
            <label className="block mb-1 text-sm text-gray-300">
              Rule Set
            </label>
            <select
              name="ruleSet"
              value={form.ruleSet}
              onChange={handleChange}
              className="w-full p-3 rounded bg-gray-800 border border-gray-700"
            >
              <option value="K-1">K-1</option>
              <option value="Muay Thai">Muay Thai</option>
              <option value="Kickboxing">Kickboxing</option>
              <option value="MMA">MMA</option>
            </select>
          </div>

          {/* STATUS */}
          <div>
            <label className="block mb-1 text-sm text-gray-300">
              Status
            </label>
            <select
              name="status"
              value={form.status}
              onChange={handleChange}
              className="w-full p-3 rounded bg-gray-800 border border-gray-700"
            >
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
          </div>

          {/* DESCRIPTION */}
          <div>
            <label className="block mb-1 text-sm text-gray-300">
              Description (optional)
            </label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              rows={4}
              placeholder="Main event, title fights, special rules..."
              className="w-full p-3 rounded bg-gray-800 border border-gray-700"
            />
          </div>

          {/* ACTIONS */}
          <div className="flex gap-3 pt-4">
            <button
              type="submit"
              className="btn btn-primary"
            >
              Create Event
            </button>
            <button
              type="button"
              className="btn bg-gray-700 hover:bg-gray-600"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
}
